import React from 'react';
import { Box } from '@mui/material';
import theme from 'theme/theme';
import { Model } from '../../hooks/useModelState';
import { PCNode } from '../../MineModel/Nodes';
import { SceneProps } from '../scene-utils';
import { Scene } from '../types';
import sideDrawerContentFunction from './ManuelNodesSceneSideDrawer';
import ModelDrawerTrigger from '../../ModelDrawerTrigger';
import getManuelNodesSceneActions from './ManuelNodesSceneActions';
import { IntersectionData } from '../../MineModel/intersectionTypes';

const TITLE = 'MANUEL NODES SCENE';

const ManuelNodesDisplay = ({ props }: { props: SceneProps }) => (
  <>
    {!props.context.state.drawerOpen && (
      <Box sx={{ position: 'absolute', right: theme.spacing(2), zIndex: 20 }}>
        <ModelDrawerTrigger handleClick={() => props.context.actions.setDrawerOpen(true)} />
      </Box>
    )}
  </>
);

const ManuelNodesScene = (props: SceneProps): Scene => {
  const display = () => <ManuelNodesDisplay props={props} />;

  const getCanvasHandlers = (model: Model) => ({
    onNodeHover: () => { },
    onNodeSelect: (node: PCNode) => {
      model.setSelectedNode(node);
    },
    // Spool tool clicks (Disconnect, Change Pipe per Spool, etc.) are intercepted
    // upstream in Stage's DispatchedCanvas. With no tool active the scene has
    // no default spool-click behavior.
    onSpoolSelect: () => { },
    onIntersections: (intersections: IntersectionData[]) => {
      // Spool intersections during an active tool are also intercepted upstream.
      const hit = intersections.find((i) => i.type === 'node');
      if (!hit) return;
      const node = hit.node ?? model.findNodeById(hit.nodeId!);
      if (node) model.setSelectedNode(node);
    },
  });

  const sideDrawerContent = (model: Model) => sideDrawerContentFunction(props, model);

  return {
    key: props.key,
    display,
    getCanvasHandlers,
    sideDrawerContent,
    title: TITLE,
    actionButtons: getManuelNodesSceneActions(),
  };
};

export default ManuelNodesScene;
